module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movieDetails"
  }, [_c('div', {
    staticClass: "bigBox"
  }, [_c('h1', [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('section', {
    staticClass: "subject-info clearfix"
  }, [_c('div', {
    staticClass: "conentL"
  }, [_c('p', {
    staticClass: "comment"
  }, [_c('strong', {
    staticClass: "grade"
  }, [_vm._v(_vm._s(_vm.star == '0' ? '尚未上映' : _vm.star))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.ratings_count) + "人评价")])]), _vm._v(" "), _c('p', [_vm._l((_vm.data.countries), function(i) {
    return _c('span', [_vm._v(_vm._s(i) + "/")])
  }), _vm._v(" "), _vm._l((_vm.data.genres), function(i) {
    return _c('span', [_vm._v(_vm._s(i) + "/")])
  }), _vm._v(" "), _vm._l((_vm.data.directors), function(i) {
    return _c('span', [_vm._v(_vm._s(i.name) + "(导演)/")])
  }), _vm._v(" "), _vm._l((_vm.data.casts), function(item, i) {
    return _c('span', [_vm._v(_vm._s(item.name) + _vm._s(i + 1 == _vm.data.casts.length ? '' : '/'))])
  }), _vm._v(" "), _c('a', {
    staticClass: "cl",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("用App查看影人资料")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "img fr"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.datai,
      "alt": "data.title"
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "subject-summary"
  }, [_c('h2', [_vm._v(_vm._s(_vm.data.title) + "的剧情简介")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n          " + _vm._s(_vm.data.summary) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-666f5c2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/movie/movie.id.vue
// module id = 60
// module chunks = 1